<template>
  <PasswordComponent />
</template>

<script>
// @ is an alias to /src
import PasswordComponent from "@/components/Account/Pages/Password/Password.vue";

export default {
  name: "Password",
  components: {
    PasswordComponent
  }
};
</script>
